// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__RRLqj","ant-page-header-heading-title":"styles_ant-page-header-heading-title__FW1J+","table":"styles_table__6mgJq"};